/* eslint-disable max-lines */
export const CustomColorPallet = {
    description:
        'TYPE: CUSTOM\nMaterial Theme Builder export 2024-09-16 04:52:20',
    seed: '#1254B3',
    logoColors: {
        teal: '#15B7C6',
        white: '#FFFFFF',
        gray: '#6B7173', // neutralVariant from materialThemeExport.coreColors.neutralVariant
    },
    coreColors: {
        // primary: '#26BDC2',
        primary: '#15B7C6',
        // primary: '#1254B3',
        // secondary: '#CC3796',
        secondary: '#9CE2FF',
        // secondary: '#4A6364',
        // tertiary: '#26BDC2',
        // tertiary: '#757780',
        tertiary: '#7EC8FF',
        success: '#26c279',
        warning: '#f29f1a',

        // tertiary: '#1254B3',
    },
    extendedColors: [],
    schemes: {
        light: {
            primary: '#455E91',
            surfaceTint: '#455E91',
            onPrimary: '#FFFFFF',
            primaryContainer: '#D8E2FF',
            onPrimaryContainer: '#001A43',
            secondary: '#874B6C',
            onSecondary: '#FFFFFF',
            secondaryContainer: '#FFD8E9',
            onSecondaryContainer: '#380726',
            tertiary: '#00696C',
            onTertiary: '#FFFFFF',
            tertiaryContainer: '#9CF1F4',
            onTertiaryContainer: '#002021',
            error: '#BA1A1A',
            onError: '#FFFFFF',
            errorContainer: '#FFDAD6',
            onErrorContainer: '#410002',
            background: '#FAF9FF',
            onBackground: '#1A1B20',
            surface: '#FAF9FF',
            onSurface: '#1A1B20',
            surfaceVariant: '#E1E2EC',
            onSurfaceVariant: '#44474F',
            outline: '#757780',
            outlineVariant: '#C5C6D0',
            shadow: '#000000',
            scrim: '#000000',
            inverseSurface: '#2F3036',
            inverseOnSurface: '#F1F0F7',
            inversePrimary: '#AEC6FF',
            primaryFixed: '#D8E2FF',
            onPrimaryFixed: '#001A43',
            primaryFixedDim: '#AEC6FF',
            onPrimaryFixedVariant: '#2C4678',
            secondaryFixed: '#FFD8E9',
            onSecondaryFixed: '#380726',
            secondaryFixedDim: '#FCB0D6',
            onSecondaryFixedVariant: '#6C3453',
            tertiaryFixed: '#9CF1F4',
            onTertiaryFixed: '#002021',
            tertiaryFixedDim: '#80D4D7',
            onTertiaryFixedVariant: '#004F52',
            surfaceDim: '#DAD9E0',
            surfaceBright: '#FAF9FF',
            surfaceContainerLowest: '#FFFFFF',
            surfaceContainerLow: '#F3F3FA',
            surfaceContainer: '#EEEDF4',
            surfaceContainerHigh: '#E8E7EF',
            surfaceContainerHighest: '#E2E2E9',
        },
        'light-medium-contrast': {
            primary: '#284274',
            surfaceTint: '#455E91',
            onPrimary: '#FFFFFF',
            primaryContainer: '#5C74A9',
            onPrimaryContainer: '#FFFFFF',
            secondary: '#67304F',
            onSecondary: '#FFFFFF',
            secondaryContainer: '#A16082',
            onSecondaryContainer: '#FFFFFF',
            tertiary: '#004B4D',
            onTertiary: '#FFFFFF',
            tertiaryContainer: '#238184',
            onTertiaryContainer: '#FFFFFF',
            error: '#8C0009',
            onError: '#FFFFFF',
            errorContainer: '#DA342E',
            onErrorContainer: '#FFFFFF',
            background: '#FAF9FF',
            onBackground: '#1A1B20',
            surface: '#FAF9FF',
            onSurface: '#1A1B20',
            surfaceVariant: '#E1E2EC',
            onSurfaceVariant: '#40434B',
            outline: '#5D5F67',
            outlineVariant: '#787A83',
            shadow: '#000000',
            scrim: '#000000',
            inverseSurface: '#2F3036',
            inverseOnSurface: '#F1F0F7',
            inversePrimary: '#AEC6FF',
            primaryFixed: '#5C74A9',
            onPrimaryFixed: '#FFFFFF',
            primaryFixedDim: '#435B8F',
            onPrimaryFixedVariant: '#FFFFFF',
            secondaryFixed: '#A16082',
            onSecondaryFixed: '#FFFFFF',
            secondaryFixedDim: '#854869',
            onSecondaryFixedVariant: '#FFFFFF',
            tertiaryFixed: '#238184',
            onTertiaryFixed: '#FFFFFF',
            tertiaryFixedDim: '#00676A',
            onTertiaryFixedVariant: '#FFFFFF',
            surfaceDim: '#DAD9E0',
            surfaceBright: '#FAF9FF',
            surfaceContainerLowest: '#FFFFFF',
            surfaceContainerLow: '#F3F3FA',
            surfaceContainer: '#EEEDF4',
            surfaceContainerHigh: '#E8E7EF',
            surfaceContainerHighest: '#E2E2E9',
        },
        'light-high-contrast': {
            primary: '#002050',
            surfaceTint: '#455E91',
            onPrimary: '#FFFFFF',
            primaryContainer: '#284274',
            onPrimaryContainer: '#FFFFFF',
            secondary: '#400E2D',
            onSecondary: '#FFFFFF',
            secondaryContainer: '#67304F',
            onSecondaryContainer: '#FFFFFF',
            tertiary: '#002728',
            onTertiary: '#FFFFFF',
            tertiaryContainer: '#004B4D',
            onTertiaryContainer: '#FFFFFF',
            error: '#4E0002',
            onError: '#FFFFFF',
            errorContainer: '#8C0009',
            onErrorContainer: '#FFFFFF',
            background: '#FAF9FF',
            onBackground: '#1A1B20',
            surface: '#FAF9FF',
            onSurface: '#000000',
            surfaceVariant: '#E1E2EC',
            onSurfaceVariant: '#21242B',
            outline: '#40434B',
            outlineVariant: '#40434B',
            shadow: '#000000',
            scrim: '#000000',
            inverseSurface: '#2F3036',
            inverseOnSurface: '#FFFFFF',
            inversePrimary: '#E6EBFF',
            primaryFixed: '#284274',
            onPrimaryFixed: '#FFFFFF',
            primaryFixedDim: '#0D2B5C',
            onPrimaryFixedVariant: '#FFFFFF',
            secondaryFixed: '#67304F',
            onSecondaryFixed: '#FFFFFF',
            secondaryFixedDim: '#4D1938',
            onSecondaryFixedVariant: '#FFFFFF',
            tertiaryFixed: '#004B4D',
            onTertiaryFixed: '#FFFFFF',
            tertiaryFixedDim: '#003334',
            onTertiaryFixedVariant: '#FFFFFF',
            surfaceDim: '#DAD9E0',
            surfaceBright: '#FAF9FF',
            surfaceContainerLowest: '#FFFFFF',
            surfaceContainerLow: '#F3F3FA',
            surfaceContainer: '#EEEDF4',
            surfaceContainerHigh: '#E8E7EF',
            surfaceContainerHighest: '#E2E2E9',
        },
        dark: {
            primary: '#AEC6FF',
            surfaceTint: '#AEC6FF',
            onPrimary: '#122F60',
            primaryContainer: '#2C4678',
            onPrimaryContainer: '#D8E2FF',
            secondary: '#FCB0D6',
            onSecondary: '#521D3C',
            secondaryContainer: '#6C3453',
            onSecondaryContainer: '#FFD8E9',
            tertiary: '#80D4D7',
            onTertiary: '#003738',
            tertiaryContainer: '#004F52',
            onTertiaryContainer: '#9CF1F4',
            error: '#FFB4AB',
            onError: '#690005',
            errorContainer: '#93000A',
            onErrorContainer: '#FFDAD6',
            background: '#121318',
            onBackground: '#E2E2E9',
            surface: '#121318',
            onSurface: '#E2E2E9',
            surfaceVariant: '#44474F',
            onSurfaceVariant: '#C5C6D0',
            outline: '#8E9099',
            outlineVariant: '#44474F',
            shadow: '#000000',
            scrim: '#000000',
            inverseSurface: '#E2E2E9',
            inverseOnSurface: '#2F3036',
            inversePrimary: '#455E91',
            primaryFixed: '#D8E2FF',
            onPrimaryFixed: '#001A43',
            primaryFixedDim: '#AEC6FF',
            onPrimaryFixedVariant: '#2C4678',
            secondaryFixed: '#FFD8E9',
            onSecondaryFixed: '#380726',
            secondaryFixedDim: '#FCB0D6',
            onSecondaryFixedVariant: '#6C3453',
            tertiaryFixed: '#9CF1F4',
            onTertiaryFixed: '#002021',
            tertiaryFixedDim: '#80D4D7',
            onTertiaryFixedVariant: '#004F52',
            surfaceDim: '#121318',
            surfaceBright: '#37393E',
            surfaceContainerLowest: '#0C0E13',
            surfaceContainerLow: '#1A1B20',
            surfaceContainer: '#1E1F25',
            surfaceContainerHigh: '#282A2F',
            surfaceContainerHighest: '#33353A',
        },
        'dark-medium-contrast': {
            primary: '#B5CAFF',
            surfaceTint: '#AEC6FF',
            onPrimary: '#001538',
            primaryContainer: '#7890C7',
            onPrimaryContainer: '#000000',
            secondary: '#FFB5DA',
            onSecondary: '#310221',
            secondaryContainer: '#C07C9F',
            onSecondaryContainer: '#000000',
            tertiary: '#84D8DC',
            onTertiary: '#001A1B',
            tertiaryContainer: '#479DA1',
            onTertiaryContainer: '#000000',
            error: '#FFBAB1',
            onError: '#370001',
            errorContainer: '#FF5449',
            onErrorContainer: '#000000',
            background: '#121318',
            onBackground: '#E2E2E9',
            surface: '#121318',
            onSurface: '#FCFAFF',
            surfaceVariant: '#44474F',
            onSurfaceVariant: '#C9CAD4',
            outline: '#A1A2AC',
            outlineVariant: '#81838C',
            shadow: '#000000',
            scrim: '#000000',
            inverseSurface: '#E2E2E9',
            inverseOnSurface: '#282A2F',
            inversePrimary: '#2E4779',
            primaryFixed: '#D8E2FF',
            onPrimaryFixed: '#00102E',
            primaryFixedDim: '#AEC6FF',
            onPrimaryFixedVariant: '#1A3566',
            secondaryFixed: '#FFD8E9',
            onSecondaryFixed: '#2A001B',
            secondaryFixedDim: '#FCB0D6',
            onSecondaryFixedVariant: '#582342',
            tertiaryFixed: '#9CF1F4',
            onTertiaryFixed: '#001415',
            tertiaryFixedDim: '#80D4D7',
            onTertiaryFixedVariant: '#003D3F',
            surfaceDim: '#121318',
            surfaceBright: '#37393E',
            surfaceContainerLowest: '#0C0E13',
            surfaceContainerLow: '#1A1B20',
            surfaceContainer: '#1E1F25',
            surfaceContainerHigh: '#282A2F',
            surfaceContainerHighest: '#33353A',
        },
        'dark-high-contrast': {
            primary: '#FCFAFF',
            surfaceTint: '#AEC6FF',
            onPrimary: '#000000',
            primaryContainer: '#B5CAFF',
            onPrimaryContainer: '#000000',
            secondary: '#FFF9F9',
            onSecondary: '#000000',
            secondaryContainer: '#FFB5DA',
            onSecondaryContainer: '#000000',
            tertiary: '#EAFFFF',
            onTertiary: '#000000',
            tertiaryContainer: '#84D8DC',
            onTertiaryContainer: '#000000',
            error: '#FFF9F9',
            onError: '#000000',
            errorContainer: '#FFBAB1',
            onErrorContainer: '#000000',
            background: '#121318',
            onBackground: '#E2E2E9',
            surface: '#121318',
            onSurface: '#FFFFFF',
            surfaceVariant: '#44474F',
            onSurfaceVariant: '#FCFAFF',
            outline: '#C9CAD4',
            outlineVariant: '#C9CAD4',
            shadow: '#000000',
            scrim: '#000000',
            inverseSurface: '#E2E2E9',
            inverseOnSurface: '#000000',
            inversePrimary: '#092859',
            primaryFixed: '#DFE6FF',
            onPrimaryFixed: '#000000',
            primaryFixedDim: '#B5CAFF',
            onPrimaryFixedVariant: '#001538',
            secondaryFixed: '#FFDEEC',
            onSecondaryFixed: '#000000',
            secondaryFixedDim: '#FFB5DA',
            onSecondaryFixedVariant: '#310221',
            tertiaryFixed: '#A0F5F8',
            onTertiaryFixed: '#000000',
            tertiaryFixedDim: '#84D8DC',
            onTertiaryFixedVariant: '#001A1B',
            surfaceDim: '#121318',
            surfaceBright: '#37393E',
            surfaceContainerLowest: '#0C0E13',
            surfaceContainerLow: '#1A1B20',
            surfaceContainer: '#1E1F25',
            surfaceContainerHigh: '#282A2F',
            surfaceContainerHighest: '#33353A',
        },
    },
    palettes: {
        primary: {
            '0': '#000000',
            '5': '#00102E',
            '10': '#001A43',
            '15': '#002357',
            '20': '#002E6B',
            '25': '#003881',
            '30': '#004397',
            '35': '#024EAD',
            '40': '#1E5BBA',
            '50': '#4074D5',
            '60': '#5D8EF1',
            '70': '#82AAFF',
            '80': '#AEC6FF',
            '90': '#D8E2FF',
            '95': '#EDF0FF',
            '98': '#FAF9FF',
            '99': '#FEFBFF',
            '100': '#FFFFFF',
        },
        secondary: {
            '0': '#000000',
            '5': '#29001B',
            '10': '#3C0029',
            '15': '#4F0036',
            '20': '#620044',
            '25': '#750053',
            '30': '#8A0061',
            '35': '#9E0071',
            '40': '#AE197E',
            '50': '#CF3998',
            '60': '#EF55B3',
            '70': '#FF80C8',
            '80': '#FFAFD7',
            '90': '#FFD8E9',
            '95': '#FFECF2',
            '98': '#FFF8F8',
            '99': '#FFFBFF',
            '100': '#FFFFFF',
        },
        tertiary: {
            '0': '#000000',
            '5': '#001415',
            '10': '#002021',
            '15': '#002B2C',
            '20': '#003738',
            '25': '#004345',
            '30': '#004F52',
            '35': '#005C5F',
            '40': '#00696C',
            '50': '#008488',
            '60': '#00A1A5',
            '70': '#26BDC2',
            '80': '#51D9DE',
            '90': '#8FF2F6',
            '95': '#BAFDFF',
            '98': '#E4FEFF',
            '99': '#F1FFFF',
            '100': '#FFFFFF',
        },
        neutral: {
            '0': '#000000',
            '5': '#101114',
            '10': '#1B1B1F',
            '15': '#252629',
            '20': '#303034',
            '25': '#3B3B3F',
            '30': '#46464A',
            '35': '#525256',
            '40': '#5E5E62',
            '50': '#77777A',
            '60': '#919094',
            '70': '#ABABAF',
            '80': '#C7C6CA',
            '90': '#E3E2E6',
            '95': '#F2F0F4',
            '98': '#FAF8FD',
            '99': '#FEFBFF',
            '100': '#FFFFFF',
        },
        'neutral-variant': {
            '0': '#000000',
            '5': '#0E1118',
            '10': '#191B23',
            '15': '#23262D',
            '20': '#2E3038',
            '25': '#393B43',
            '30': '#44474F',
            '35': '#50525A',
            '40': '#5C5E67',
            '50': '#757780',
            '60': '#8E9099',
            '70': '#A9ABB4',
            '80': '#C5C6D0',
            '90': '#E1E2EC',
            '95': '#EFF0FA',
            '98': '#FAF9FF',
            '99': '#FEFBFF',
            '100': '#FFFFFF',
        },
    },
};
/* eslint-enable max-lines */
